export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11929.4529f833.jpg";